/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Live_Caption_Rollup_RowsInputs */

const en_live_caption_rollup_rows = /** @type {(inputs: Live_Caption_Rollup_RowsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Roll-up rows`)
};

const fr_live_caption_rollup_rows = /** @type {(inputs: Live_Caption_Rollup_RowsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rangées enroulées`)
};

const de_live_caption_rollup_rows = /** @type {(inputs: Live_Caption_Rollup_RowsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aufrollbare Reihen`)
};

const it_live_caption_rollup_rows = /** @type {(inputs: Live_Caption_Rollup_RowsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`file arrotolabili`)
};

const ru_live_caption_rollup_rows = /** @type {(inputs: Live_Caption_Rollup_RowsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Свернутые ряды`)
};

const es_live_caption_rollup_rows = /** @type {(inputs: Live_Caption_Rollup_RowsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filas enrollables`)
};

const zh_cn2_live_caption_rollup_rows = /** @type {(inputs: Live_Caption_Rollup_RowsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`卷起行`)
};

const ja_live_caption_rollup_rows = /** @type {(inputs: Live_Caption_Rollup_RowsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ロールアップ列`)
};

const hi_live_caption_rollup_rows = /** @type {(inputs: Live_Caption_Rollup_RowsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`रोल-अप पंक्तियाँ`)
};

const pt_pt2_live_caption_rollup_rows = /** @type {(inputs: Live_Caption_Rollup_RowsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`fileiras de enrolar`)
};

/**
* | output |
* | --- |
* | "Roll-up rows" |
*
* @param {Live_Caption_Rollup_RowsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const live_caption_rollup_rows = /** @type {((inputs?: Live_Caption_Rollup_RowsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Live_Caption_Rollup_RowsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_live_caption_rollup_rows(inputs)
	if (locale === "de") return de_live_caption_rollup_rows(inputs)
	if (locale === "it") return it_live_caption_rollup_rows(inputs)
	if (locale === "ru") return ru_live_caption_rollup_rows(inputs)
	if (locale === "es") return es_live_caption_rollup_rows(inputs)
	if (locale === "zh-CN") return zh_cn2_live_caption_rollup_rows(inputs)
	if (locale === "ja") return ja_live_caption_rollup_rows(inputs)
	if (locale === "hi") return hi_live_caption_rollup_rows(inputs)
	if (locale === "pt-PT") return pt_pt2_live_caption_rollup_rows(inputs)
	return en_live_caption_rollup_rows(inputs)
});